import React, {Component} from 'react';

import './LoaderScreen.css';
// import orangeLogo from '../../images/just-b-ro.svg';
// import blackLogo from '../../images/just-b-black.svg';
import OrangeLogo from './SvgRo';
import BlackLogo from './SvgBlack';

class LoaderScreen extends Component {

  constructor(props) {
    super(props);

    this.state = {
      init: true,
      fadeout: false,
      remove: false,
      animating: false
    }

    this.removeFunction = this.removeFunction.bind(this);
    this.addFunction = this.addFunction.bind(this);
  }

  removeFunction() {
    this.setState({
      fadeout: true
    }, () => {
      window.setTimeout(()=> {
        this.setState({
          remove: true,
          fadeout: false,
          animating: false
        })
      }, 1200)
    })
  }

  addFunction() {
    this.setState({
      fadeout: false,
      remove: false
    }, () => {
      setTimeout(() => {
        this.setState({
          animating: true
        })
      }, 200);
    })

  }

  componentDidMount() {
    this.setState({
      animating: true
    })
  }

  componentDidUpdate(prevProps) {
    if(this.props.loading !== prevProps.loading) {
      if(this.props.loading) {
        this.addFunction();
      } else {
        this.removeFunction();
      }
    }
  }

  render() {
    
    return(
      <div 
        className="loader"
        style={{
          display: this.state.remove ? 'none' : '',
          opacity: this.state.fadeout ? 0 : 1
        }}>
        <div className="loader-bg"></div>
        <div className="logo-wrap">
          <div className="logo">
            <h1 className="relative">
              <div className="absolute">
                <div className="absolute w3 h3 center-hack background-logo-orange">
                  <OrangeLogo />
                </div>
                <div 
                  className="absolute w3 h3 center-hack background-logo"
                  style={{height: this.state.animating ? '0rem' : '4rem'}}>
                  <BlackLogo />
                </div>
              </div>
            </h1>
          </div>
        </div>
      </div>
    )
  }
}

export default LoaderScreen;